var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134.56mm",
    height: "102.81mm",
    viewBox: "0 0 134.56 102.81",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16015"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m242.25 57.75h221.25v220.5h-221.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16049"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16079"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16089"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.2207e-4 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16099"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 540h960v-540l-960-6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m414 64.5h205.5v205.5h-205.5z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-608.54 -424)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 523.88 551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240 68.571h381.43v291.43h-381.43z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16015)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 21.7742 37.564098 54.075001 65.322601 83.347603 95.352249 104.4008 120.1907 137.45865 147.9492 165.21715 177.2218 186.99135 196.76089 205.77341 214.7859",
    y: 0
  }, "Lay brick or tile"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16027)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,249.65,495.55)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "36.05px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 12.00465 36.049999",
    y: 0
  }, "(R)"))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.0729,-9.4e-8,-3.77e-7,3.0625,242.25,57.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.384 58.116h-60v-9h3v-36h54v36h3zm-55.5-18h6.75v-7.5h-6.75zm24.75 0v-7.5h-16.5v7.5zm18 0v-7.5h-16.5v7.5zm-25.5-16.5v7.5h16.5v-7.5zm-17.25 7.5h15.75v-7.5h-15.75zm24.75-9v-7.5h-16.5v7.5zm1.5 0h16.5v-7.5h-16.5zm9 1.5v7.5h15.75v-7.5zm9 9v7.5h6.75v-7.5zm-9 9v7.5h15.75v-7.5zm-1.5 0h-16.5v7.5h16.5zm-18 0h-15.75v7.5h15.75zm-15.75-19.5h6.75v-7.5h-6.75zm44.25-7.5v7.5h6.75v-7.5zm-47.25 36v6h57v-6z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m437.63 251.25c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.63 251.25c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.13 261.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.13 261.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.38 261.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.38 261.75c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m479.9 259.57c0-1.08-0.87-1.95-1.95-1.95-1.07 0-1.95 0.87-1.95 1.95 0 1.07 0.88 1.94 1.95 1.94 1.08 0 1.95-0.87 1.95-1.94z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m498.84 259.76c0-1.07-0.88-1.94-1.95-1.94-1.08 0-1.95 0.87-1.95 1.94 0 1.08 0.87 1.95 1.95 1.95 1.07 0 1.95-0.87 1.95-1.95z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.13 293.62 25.5 49.5 25.5-49.5z",
    fill: "#4472c4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m460.13 293.62 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m523.17 257.1 16.44 10.59c9.07 5.85 19.01 6.58 22.2 1.64 3.19-4.95-1.59-13.7-10.66-19.55l-16.43-10.59z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m523.17 257.1 16.44 10.59c9.07 5.85 19.01 6.58 22.2 1.64 3.19-4.95-1.59-13.7-10.66-19.55l-16.43-10.59z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m450.09 227.19-13.49 4.27c-7.44 2.35-12.32 7.93-10.89 12.46s8.63 6.29 16.08 3.93l13.48-4.26z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m450.09 227.19-13.49 4.27c-7.44 2.35-12.32 7.93-10.89 12.46s8.63 6.29 16.08 3.93l13.48-4.26z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m508.88 228.75c0-5.59-7.06-10.13-15.75-10.13-8.7 0-15.75 4.54-15.75 10.13h5.06c0-2.8 4.78-5.06 10.69-5.06 5.9 0 10.68 2.26 10.68 5.06z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m508.88 228.75c0-5.59-7.06-10.13-15.75-10.13-8.7 0-15.75 4.54-15.75 10.13h5.06c0-2.8 4.78-5.06 10.69-5.06 5.9 0 10.68 2.26 10.68 5.06z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16123)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8542,0,-3.77e-7,2.8542,414,64.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath16133)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.134 49.866h-36.75v-37.5h54v28.5h-17.25zm-1.5-9h-16.5v7.5h16.5zm-9-1.5v-7.5h-16.5v7.5zm-7.5-16.5v7.5h16.5v-7.5zm-1.5 7.5v-7.5h-15.75v7.5zm9-9v-7.5h-16.5v7.5zm1.5 0h16.5v-7.5h-16.5zm9 1.5v7.5h15.75v-7.5zm-9 9v7.5h16.5v-7.5zm-26.25 16.5h15.75v-7.5h-15.75zm6.75-9v-7.5h-6.75v7.5zm-6.75-18h6.75v-7.5h-6.75zm44.25-7.5v7.5h6.75v-7.5zm6.75 18h-6.75v7.5h6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.484 58.306-3.496 8.292-16.587-6.993 3.497-8.292zm-4.297 6.327 2.333-5.529-13.823-5.826-2.331 5.528z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.525f11a927e65a2d13164fae6f9505ed.svg";
export { ForwardRef as ReactComponent };